import { useState } from 'react';
import { apiURL } from '../../consts/URLs';
import { RETURNRULES } from '../endpointList';
import { fetchRequest, getOptions } from '../utils';
import { getCookie } from '../../utils/handleCookie';
import { cookieName } from '../../consts/cookie';

export interface Category {
    name: string;
    ordering: string;
}

const token = getCookie(cookieName.token);

const useReturnRules = () => {
    const [getReturnRulesResponse, setGetReturnRulesResponse] = useState<any>();
    const [getReturnRulesResult, setGetReturnRulesResult] = useState<any>();

    const [createReturnRulesResponse, createGetReturnRulesResponse] = useState<any>();
    const [createReturnRulesResult, createGetReturnRulesResult] = useState<any>();

    const [deleteReturnRulesResponse, setDeleteReturnRulesResponse] = useState<any>();
    const [deleteReturnRulesResult, setDeleteReturnRulesResult] = useState<any>();

    const [updateReturnRulesResponse, setUpdateReturnRulesResponse] = useState<any>();
    const [updateReturnRulesResult, setUpdateReturnRulesResult] = useState<any>();

    const getReturnRules = () => {
        const url = `${apiURL}/${RETURNRULES}`;
        const options = getOptions({ method: 'GET', token: token });
        fetchRequest(url, options, setGetReturnRulesResponse, setGetReturnRulesResult);
    };

    const createReturnRule = (obj: any) => {
        const url = `${apiURL}/${RETURNRULES}?name=${encodeURI(obj.name)}`;
        const options = getOptions({ method: 'POST', token: token });
        fetchRequest(url, options, createGetReturnRulesResponse, createGetReturnRulesResult);
    };

    const deleteReturnRule = (id: number) => {
        const url = `${apiURL}/${RETURNRULES}/${id}/delete`;
        const options = getOptions({ method: 'DELETE', token: token });
        fetchRequest(url, options, setDeleteReturnRulesResponse, setDeleteReturnRulesResult);
    };

    const updateReturnRule = (obj: any) => {
        const url = `${apiURL}/${RETURNRULES}/${obj.id}?name=${encodeURI(obj.name)}`;
        const options = getOptions({ method: 'PUT', token: token });
        fetchRequest(url, options, setUpdateReturnRulesResponse, setUpdateReturnRulesResult);
    };

    const RESPONSES = {
        getReturnRulesResponse,
        createReturnRulesResponse,
        deleteReturnRulesResponse,
        updateReturnRulesResponse,
    };

    const RESULTS = {
        getReturnRulesResult,
        createReturnRulesResult,
        deleteReturnRulesResult,
        updateReturnRulesResult,
    };

    const CTAs = {
        getReturnRules,
        createReturnRule,
        deleteReturnRule,
        updateReturnRule,
    };

    return { RESPONSES, RESULTS, CTAs };
};
export default useReturnRules;
